import React, { PropsWithChildren, ReactElement } from 'react';

import { TParagraphProperties } from './paragraph.types';
import { StyledParagraph } from './paragraph.styled';

export function Paragraph({
    marginTop = 'medium',
    marginBottom = 'medium',
    small = false,
    color,
    children,
    align,
    ...otherProperties
}: PropsWithChildren<TParagraphProperties>): ReactElement | null {
    if (!children) {
        return null;
    }

    return (
        <StyledParagraph
            marginTop={marginTop}
            marginBottom={marginBottom}
            small={small}
            color={color}
            align={align}
            {...otherProperties}
        >
            {children}
        </StyledParagraph>
    );
}
